import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoIi: CultureInfo = {
  name: 'ii',
  displayName: 'Sichuan Yi',
  iso3LanguageCode: 'iii',
  iso2LanguageCode: 'ii',
  ietfLanguageTag: 'ii',
  parent: null
};
